import * as React from 'react';
export const IcFire = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.73 2.77l-.52-.48a1 1 0 00-1.7.87 7.91 7.91 0 01-.9 4.52A14.999 14.999 0 017 10a7.55 7.55 0 00-2 5 6.86 6.86 0 007 7 6.858 6.858 0 007-7c0-5.74-5.28-10.46-7.27-12.23zM12 20a2.43 2.43 0 01-1.81-4.12 3.2 3.2 0 00.51-.83 5.51 5.51 0 00.3-1.55.5.5 0 01.31-.46.47.47 0 01.54.11l.17.15c.68.6 2.48 2.21 2.48 4.2A2.45 2.45 0 0112 20z'
      fill='currentColor'
    />
  </svg>
);
